// Path: apps/0001-estata.com/frontend/src/lib/sessionEntry.ts
// v1.0.0 - Reihenfolge bei lebender Sitzung (Inhaber, 12.10.2026: "wenn ich mehrere Mandanten habe, dann sollte der
//          Passcode vorher kommen. Und dann waehle ich den Mandanten."): der Passcode gehoert zur Person und zum
//          Geraet und schliesst die App auf - erst danach kommt die Wahl des Mandanten (oder der Bereich direkt).

export type SessionEntryStep = 'passcode' | 'choose' | 'direct';

/** Erster Schritt fuer eine lebende Sitzung: Tab noch zu -> Passcode; sonst bei mehreren Zielen die Auswahl. */
export function sessionEntryStep(unlocked: boolean, targetCount: number): SessionEntryStep {
  if (!unlocked) return 'passcode';
  return targetCount >= 2 ? 'choose' : 'direct';
}
